/* eslint-disable no-unused-vars */
import styled from 'styled-components/macro';
import Heading from 'components/atoms/Heading';
import LoginTemplate from 'components/templates/LoginTemplate';
import MailIcon from 'assets/images/readed-mail.svg';
import Button from 'components/atoms/Button';
import { useContext } from 'react';
import Field from '../components/molecules/Field';
import Form, { useForm } from '../components/molecules/Form';
import { StyledForm } from '../components/organisms/Login/Login.styles';
import { AuthContext } from '../context/authContext';

export const IconHolder = styled.div`
  width: 100px;
  height: 100px;
  background: linear-gradient(
    268.95deg,
    rgba(41, 37, 88, 0.536345) 4.06%,
    rgba(38, 35, 83, 0.866791) 42.35%,
    rgba(33, 30, 75, 0.50218) 99.53%
  );
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 30px;
  @media (min-width: 992px) {
    width: 129px;
    height: 129px;
  }
`;

export default function CheckEmail() {
  const { onResendEmail, user, loading } = useContext(AuthContext);

  const onSubmit = async value => {
    const id = user._id;
    const email = value.email.toLowerCase();
    const values = { email, id };
    onResendEmail({ values });
  };
  const [form] = useForm();
  return (
    <LoginTemplate backButton>
      <IconHolder>
        <img src={MailIcon} alt="mail" />
      </IconHolder>
      <Heading level={1}>Resend Activation Email</Heading>
      <StyledForm form={form} onSubmit={onSubmit}>
        <Form.Item
          bgLight
          type="text"
          label="Email"
          name="email"
          placeholder="Your Email"
          prefix={<i className="material-icons-outlined">email</i>}
          rules={[{ required: true }, { pattern: /^.{0,256}$/, message: 'Maximum Character Length is 256' }]}>
          <Field />
        </Form.Item>
        <Button loading={loading} type="primary" htmlType="submit">
          Resend Email
        </Button>
      </StyledForm>
    </LoginTemplate>
  );
}
